/**
 * Loga ações não reconhecidas
 */
export function handleUnknown(action) {
  console.warn(`⚠️ Tipo de ação desconhecida: ${action}`);
  throw new Error(`⚠️ Tipo de ação desconhecida: ${action}`)
}
